(function HotelEngineHotelDetails($, Adzuki)
{
	"use strict";

	var map    = null;
	var $modal = $('#modalWindow');

	$(document).ready(function documentReady()
	{
		var pages = [
			'HotelEngine/hotelDetails',
			'HotelEngine/displayBooking'
		];

		var max_time      = 600, // max amount of seconds before we say to retry
			current_timer = 0,
			interval;

		Adzuki.onload(pages, function onload() {
			$('.ajax-image-gallery').click(function _showGallery() {
				var $el = $(this),
					index = parseInt($(this).data('index')),
					hotel_gallery = null,
					url = '/HotelEngine/getGalleryImages/',
					giata_id = $el.data('giata-id') || $el.parent().data('giata-id');

				if (Adzuki.init_page === 'HotelEngine/hotelDetails') {
					if (!giata_id) {
						throw new Error('missing giata-id');
					}

					url += giata_id;
				}

				// hit a different ajax url if on the Hotel Enging Booking Completed screen
				if (Adzuki.init_page === 'HotelEngine/displayBooking') {
					url = '/HotelEngine/getBookingGalleryImages/';
				}

				Adzuki.Ajax.post(url).then(function sucess(response) {
					var images = response;
					var gallery_images = [];

					if (images.length === 0) {
						return;
					}

					$.each(images, function onEachImage(i, image) {
						gallery_images.push({
							src    : image.src,
							thumb  : image.thumb,
							subHtml: image.subHtml,
						});
					});

					hotel_gallery = lightGallery($el[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						index            : index,
						dynamicEl        : gallery_images,
					});

					hotel_gallery.openGallery();
				});
			});

			$('.hotel-engine-room-image').click(function _showRoomGallery() {
				var room_gallery = null,
					$self = $(this),
					image_json = $self.data('gallery-images');

				room_gallery = lightGallery($self[0], {
					licenseKey       : 'github',
					download         : false,
					plugins          : [lgThumbnail],
					dynamic          : true,
					thumbnail        : true,
					toggleThumb      : true,
					allowMediaOverlap: true,
					dynamicEl        : image_json,
				});

				room_gallery.openGallery();
			});

			$('.rate-select').on('change', function swapRate() {
				var $self = $(this),
					$room = $self.closest('.hotel-engine-room'),
					$select = $room.find('a.select-rate'),
					data = $self.data(),
					booking_uri = '/HotelEngine/processor/selectRoom/' + data['rateSelect'];

				$room.find('.per-night').html(data['nightly']);
				$room.find('.taxes-fees').html(data['taxesFees']);
				$room.find('.savings-pct').html(data['savings']);
				$room.find('.selling-price').html(data['sellingPrice']);

				// Update booking link
				$select.attr('href', Adzuki.get_url(booking_uri));
				$select.attr('data-uri', Adzuki.get_url(booking_uri));
			});


			$(document).ready(function documentReadyHandler() {
				// Inject highlight style
				$('<style>.bg-warning { background-color: yellow; color: black; padding: 0 2px; border-radius: 2px; }</style>').appendTo('head');

				// Store original room names
				$('.card-body.room-block').each(function storeOriginalRoomName() {
					const $b = $(this).find('.room-name h4 b');
					if ($b.length && !$b.attr('data-original')) {
						$b.attr('data-original', $b.text().trim());
					}
				});

				$('#keyword-search').on('keyup', function handleKeywordSearchKeyup() {
					const str_value = $(this).val().trim();
					const regex = new RegExp(`(${str_value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
					let matchCount = 0;

					$('.card-body.room-block').not('#additionalRatesModal .card-body.room-block').each(function filterRoomBlocks() {

						const $roomBlock = $(this);
						const $b = $roomBlock.find('.room-name h4 b');
						const $roomWrapper = $roomBlock.closest('.room-container').length
							? $roomBlock.closest('.room-container')
							: $roomBlock.closest('.rate-options').parent();

						const original = $b.attr('data-original');
						if (!original) {
							return;
						}


						let nameMatch = false;
						let tableMatch = false;
						let amenityMatch = false;
						let detailsMatch = false;

						// Restore room name
						$b.html(original);

						// Match room name
						if (str_value.length >= 3 && original.toLowerCase().includes(str_value.toLowerCase())) {
							const highlighted = original.replace(regex, '<span class="bg-warning">$1</span>');
							$b.html(highlighted);
							nameMatch = true;
						}

						// Match rate table cells
						const $tableCells = $roomBlock.find('.hotel-engine-room-rates td');
						$tableCells.each(function highlightTableCell() {
							const $cell = $(this);

							// Store original HTML once
							if (!$cell.attr('data-original-html')) {
								$cell.attr('data-original-html', $cell.html());
							}

							const originalHtml = $cell.attr('data-original-html');
							const textOnly = $('<div>').html(originalHtml).text();

							if (str_value.length >= 3 && textOnly.toLowerCase().includes(str_value.toLowerCase())) {
								const highlighted = textOnly.replace(regex, '<span class="bg-warning">$1</span>');
								$cell.html(highlighted);
								tableMatch = true;
							} else {
								$cell.html(originalHtml);
							}
						});

						// Match amenities container
						const $amenities = $roomBlock.find('.amenities-container span');
						$amenities.each(function highlightAmenityItem() {
							const $item = $(this);
							if (!$item.attr('data-original')) {
								$item.attr('data-original', $item.text());
							}

							const originalText = $item.attr('data-original');
							if (str_value.length >= 3 && originalText.toLowerCase().includes(str_value.toLowerCase())) {
								const highlighted = originalText.replace(regex, '<span class="bg-warning">$1</span>');
								$item.html(highlighted);
								amenityMatch = true;
							} else {
								$item.html(originalText);
							}
						});

						// Match more-details span
						const $moreDetails = $roomBlock.find('.room-name .more-details');
						$moreDetails.each(function highlightMoreDetails() {
							const $detail = $(this);
							if (!$detail.attr('data-original')) {
								$detail.attr('data-original', $detail.text());
							}

							const originalDetail = $detail.attr('data-original');
							if (str_value.length >= 3 && originalDetail.toLowerCase().includes(str_value.toLowerCase())) {
								const highlighted = originalDetail.replace(regex, '<span class="bg-warning">$1</span>');
								$detail.html(highlighted);
								detailsMatch = true;
							} else {
								$detail.html(originalDetail);
							}
						});

						// Visibility decision
						if (str_value.length >= 3) {
							if (nameMatch || tableMatch || amenityMatch || detailsMatch) {
								$roomWrapper.show();
								matchCount++;
							} else {
								$roomWrapper.hide();
							}
						} else {
							// Reset table
							$tableCells.each(function resetTableCell() {
								const $cell = $(this);
								if ($cell.attr('data-original-html')) {
									$cell.html($cell.attr('data-original-html'));
								}
							});

							// Reset amenities
							$amenities.each(function resetAmenityItem() {
								const $item = $(this);
								if ($item.attr('data-original')) {
									$item.html($item.attr('data-original'));
								}
							});

							// Reset more-details
							$moreDetails.each(function resetMoreDetails() {
								const $detail = $(this);
								if ($detail.attr('data-original')) {
									$detail.html($detail.attr('data-original'));
								}
							});

							// Reset name
							$b.html(original);
							$roomWrapper.show();
							matchCount++;
						}
					});

					// Show/hide clear button
					$('.btn-clear').css('visibility', str_value.length >= 3 ? 'visible' : 'hidden');

					// Update result count and alert
					updateResultCount(matchCount, str_value);
				});
			});


			function updateResultCount(visibleCount, searchTerm) {
				$('.result-count').text('(' + visibleCount + ')');
				$('#no-results-alert').remove();

				if (visibleCount === 0 && searchTerm.length >= 3) {
					$('<div id="no-results-alert" class="alert alert-info mt-3" role="alert">'
						+ 'No results found for your search: <strong>' + searchTerm + '</strong>'
						+ '</div>').insertAfter('#keyword-search');
				}
			}


			// $('.hotel-engine-room-additional-rate-label').on('click', showAllRates);
			$(document).on('click', '.hotel-engine-room-additional-rate-label', showAllRates);

			function decodeHtmlEntities(str) {
				const txt = document.createElement('textarea');
				txt.innerHTML = str;
				return txt.value;
			}


			function showAllRates(e) {
				e.preventDefault();

				const $btn = $(this);
				const roomId = $btn.data('room-id');
				const roomName = $btn.data('room-name');
				const additionalInfo = $btn.data('additional-info');
				const $modal = $('#additionalRatesModal');

				// Get the <template> content
				const template = document.querySelector(`template.full-room-rate-template[data-room-id="${roomId}"]`);
				const clone = template.content.cloneNode(true);

				// Remove modal-triggering behavior from cloned elements
				$(clone).find('.room-details-modal-trigger')
					.removeAttr('data-toggle data-target')
					.removeClass('room-details-modal-trigger')
					.addClass('room-details-row-trigger');

				// Clear old additional-info if it exists
				$modal.find('.additional-info').remove();

				// Update modal title and body
				$modal.find('.modal-title').text(roomName);

				// Add new additional-info
				$modal.find('.modal-title')
					.after(`<div class="additional-info text-muted" style="font-size: 1.5rem;">${additionalInfo}</div>`);

				$modal.find('.modal-body').html(clone);
				$modal.modal('show');
			}



			$(document).on('click', '.room-details-row-trigger', function handleRoomDetailsRowClick(e) {
				e.preventDefault();

				const $link = $(this);
				const encodedDescription = $link.data('description');
                const roomId = $link.data('room-id');
				// Decode HTML entities and fix escaped slashes
				const description = decodeHtmlEntities(encodedDescription).replace(/\\\//g, '/');

				const $currentRow = $link.closest('tr');

				// Check if description row is already inserted
				const $nextRow = $currentRow.next('.room-description-row');

                if ($nextRow.length > 0) {
                    const isVisible = $nextRow.is(':visible');
                    $nextRow.toggle();
                    $nextRow.attr('data-visible', !isVisible); // Track state
                    return;
                }

				const colspan = $currentRow.children('td').length;
                const $descriptionRow = $(`
                    <tr class="room-description-row" style="display: table-row; background-color: #d9edf7;" data-visible="true" data-room-id="${roomId}">
                        <td colspan="${colspan}">
                            <div style="margin-left: 30px;"></div>
                        </td>
                    </tr>
                `);

				$descriptionRow.find('div').html(description);
				$currentRow.after($descriptionRow);
			});



			$(document).on('input', '#modal-keyword-search', function modalKeywordSearch() {
				const keyword = $(this).val().trim().toLowerCase();
				const $modal = $('#additionalRatesModal');
				const $rows = $modal.find('.hotel-engine-room-rates tr').not('.room-description-row');

				let anyMatch = false;


                if (keyword.length > 0 && keyword.length < 3) {
                    $rows.show(); // Show all data rows

                    $modal.find('.room-description-row').each(function toggleRoomDescriptionRow() {
                        const $descRow = $(this);
                        if ($descRow.attr('data-visible') === 'true') {
                            $descRow.show();
                        } else {
                            $descRow.hide();
                        }
                    });

                    $modal.find('#modal-no-results-alert').hide();
                    return;
                }



                $rows.each(function filterAndHighlightRows() {
					const $row = $(this);
					let matchFound = false;

					// Reset highlights
					$row.find('td').each(function restoreOriginalCellHtml() {
						const $cell = $(this);
						const originalHtml = $cell.data('originalHtml');
						if (originalHtml) {
							$cell.html(originalHtml);
						} else {
							$cell.data('originalHtml', $cell.html());
						}
					});

					if (keyword === '') {
						$row.show();
						anyMatch = true;
						return;
					}

					$row.find('td').each(function highlightMatchingCell() {
						const $cell = $(this);
						const cellText = $cell.text().toLowerCase();
						if (cellText.includes(keyword)) {
							highlightTextNodes($cell, keyword);
							matchFound = true;
						}
					});

					if (matchFound) {
						$row.show();
						anyMatch = true;
					} else {
						$row.hide();
					}
				});

                $modal.find('.hotel-engine-room-rates tr.room-description-row').each(function toggleVisibleRoomDescriptions() {
                    const $descRow = $(this);
                    if ($descRow.attr('data-visible') === 'true') {
                        $descRow.show();
                    } else {
                        $descRow.hide();
                    }
                });

                
                // Toggle modal no-results alert
				const $noResultsAlert = $modal.find('#modal-no-results-alert');
				if (!anyMatch && keyword !== '') {
					$noResultsAlert.show().find('strong').text(keyword);
				} else {
					$noResultsAlert.hide();
				}

				$('#additionalRatesModal').on('hidden.bs.modal', function clearModalSearchOnClose() {
					// Clear modal search input
					$('#modal-keyword-search').val('');

					// Trigger input handler to reset table
					$('#modal-keyword-search').trigger('input');
				});

			});



			$('.room-details-modal-trigger').on('click', function handleRoomDetailsClick() {
				const raw = $(this).attr('data-description');  // get raw string from attribute
				console.log('raw data-description:', raw);
				const description = JSON.parse(raw);
				const target = $(this).data('target');
				$(target + ' .modal-body').html(description);
			});


			function highlightTextNodes($element, keyword) {
				const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape regex special chars
				const regex = new RegExp(`(${escapedKeyword})`, 'gi');

				$element.contents().each(function textNodeHighlighter() {
					if (this.nodeType === 3) { // text node
						const text = this.nodeValue;
						if (text.toLowerCase().includes(keyword.toLowerCase())) {
							const highlighted = text.replace(regex, match => `<span style="background-color: yellow; color: black; padding: 0 2px; border-radius: 2px;">${match}</span>`);
							$(this).replaceWith(highlighted);
						}
					} else if (this.nodeType === 1) {
						highlightTextNodes($(this), keyword); // recursive
					}
				});
			}




			$modal.on('click', '.rate-details', function _showRateDetals(e) {
				var index = $(this).data('index'),
					details = $(this).data('details'),
					raw = JSON.stringify($(this).data('raw'), null, 2),
					more_details = $(this).data('more-details'),
					policies = $(this).data('policies');

				e.preventDefault();

				// reset the row color
				$('.rate-row').each(function _itierateRow(key, val) {
					if (key % 2 === 0) {
						$(this).css('background-color', '#f9f9f9');
					} else {
						$(this).css('background-color', '#ffffff');
					}
				});

				$('.rate-row[data-index="' + index + '"]').css('background-color', '#CDE4F7');
				$('.rate-detail-information').html(details);
				$('.rate-detail-raw').html('<h4>Rate Data</h4><pre><code>' + raw + '</code></pre>');
				$('#more_details').html('<div class="pad10">' + more_details + '</div>');
				$('#policies').html('<div class="pad10">' + policies + '</div>');
			});

			loadMap();
			loadReviews();
			initSpecialtyBadges();

			interval = setInterval(
				function _updateCurrentTimer() {
					// console.log(current_timer);

					if (current_timer >= max_time) {
						clearInterval(interval);

						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'You have been on this page longer than ' + max_time / 60 + ' minutes. It is recommended to reload this hotel\'s details. Would you like to reload it now?',
							confirm: function confirm() {
								document.location = Adzuki.base_uri + '/HotelEngine/processor/selectHotel/' + $('#giata_id').val();
							}
						});
					}

					current_timer++;
				},
				1000
			);

			showSpecialtyRates();

			// Handle "Show All" amenities button
			$('.show-all-amenities').on('click', function toggleAmenities(e) {
				var $btn = $(this);
				var $hiddenAmenities = $btn.siblings('.hidden-amenities');

				e.preventDefault();

				if ($hiddenAmenities.is(':visible')) {
					$hiddenAmenities.hide();
					$btn.text('Show All Room Features');
				} else {
					$hiddenAmenities.css({
						display : 'flex',
						flexWrap: 'wrap',
					});
					$btn.text('Show Less');
				}
			});
		});
	});

	function initSpecialtyBadges() {
		$('.specialty-badge').on('click', function click(e) {
			e.preventDefault();

			$modal.find('.modal-title').text('SPECIALTY RATE PROGRAM');
			$modal.find('.modal-body').html('<span class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-2x fa-spin"></span> Retrieving specialty rate information...');
			$modal.modal('show');

			Adzuki.Ajax.get('/HotelEngine/loadSpecialtyRateDetails/' + encodeURIComponent($(this).data('sabre-hotel-id')) + '/' + encodeURIComponent($(this).data('rate-code')))
				.then(function content(content) {
					$modal.find('.modal-body').html(content);
				});
		});
	}

	function loadMap() {
		if (map === null) {
			map = new Adzuki.Map(
				$('.hotel-map'), {
					zoom: 15,
					init: function map_init(_map) {
						_map.populate($('.hotel-map').data('map-markers'));
					}
				}
			);
		}
	}

	function loadReviews()
	{
		var giata_id = $('#giata_id').val();

		if (giata_id) {
			Adzuki.Ajax.get('/HotelEngine/reviews/' + giata_id)
				.then(function success(response) {
					$('.review-content').html(response);
				});
		}
	}

	function showSpecialtyRates()
	{
		if ($('#show-specialty-rates').length > 0 && parseInt($('#show-specialty-rates').data('value')) === 1) {
			if ($('#specialty-rate-tab').length > 0) {
				$('#specialty-rate-tab').trigger('click');
			} else {
				Adzuki.StatusMessage('warning', 'Unfortunately the selected hotel does not currently have any available specialty rates. All other available rates are shown instead.');
			}
		}
	}
}(jQuery, window.Adzuki || {}));